import React from 'react';
import BaseInputFilter from './baseInputFilter.jsx';
import { clearTimeout, setTimeout } from 'timers';

export default class GridStringFilter extends BaseInputFilter {
    constructor(args) {
        super(args);

        this.state.initOperation = "contains";
        this.state.operations = [
            {
                "key": "contains",
                "name": "Содержит"
            },
            {
                "key": "not-contains",
                "name": "Не содержит"
            },
            {
                "key": "starts-with",
                "name": "Начинается с"
            },
            {
                "key": "ends-with",
                "name": "Оканчивается на"
            },
            {
                "key": "equals",
                "name": "Равно"
            },
            {
                "key": "not-equals",
                "name": "Не равно"
            }
        ];

        this.changeTimer = null;
    }

    ensureFilterValue() {
        if (!this.state.value) {
            this.state.value = {
                fieldName: this.state.column.fieldName,
                operation: this.state.initOperation,
                value: ""
            };
        }
    }

    handleFilterValueChanged(e) {
        let newValue = e.target.value;
        if (newValue) {
            this.ensureFilterValue();
            this.state.value.value = newValue;
        } else {
            this.state.value = null;
        }

        if (this.changeTimer) {
            clearTimeout(this.changeTimer);
        }
        this.changeTimer = setTimeout(() => this.handleEndValueEdit(), 1000);

        this.setState({ value: this.state.value });
    }

    handleEndValueEdit() {
        if (this.changeTimer) {
            clearTimeout(this.changeTimer);
            this.changeTimer = null;
        }
        this.applyFilterChanges();
    }

    handleInputKeyDown(e) {
        if (e.keyCode === 13) {
            this.handleEndValueEdit();
        }
    }

    render() {
        let filterValue = this.state.value ? this.state.value.value : "";
        let operations = this.renderOperationsList();

        return (
            <div className="input-group">
                {operations}
                <input type="text"
                    className="form-control"
                    value={filterValue}
                    onChange={e => this.handleFilterValueChanged(e)}
                    onBlur={() => this.handleEndValueEdit()}
                    onKeyDown={e => this.handleInputKeyDown(e)}
                    disabled={this.props.disabled}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./App/grid/filter/stringFilter.jsx